import { render, staticRenderFns } from "./FlixBus.vue?vue&type=template&id=54c941a6&"
import script from "./FlixBus.vue?vue&type=script&lang=js&"
export * from "./FlixBus.vue?vue&type=script&lang=js&"
import style0 from "./FlixBus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports